
import { call, put, takeEvery } from "redux-saga/effects"

// Redux States
import {
    GET_PLANS,
    ADD_NEW_PLAN,
    DELETE_PLAN,
    UPDATE_PLAN,
} from "./actionTypes"

import {
    getPlansSuccess,
    getPlansFail,
    addNewPlanSuccess,
    addNewPlanFail,
    updatePlanSuccess,
    updatePlanFail,
    deletePlanSuccess,
    deletePlanFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
    getPlans,
    addNewPlan,
    updatePlan,
    deletePlan,
} from "../../helpers/fakebackend_helper"

function* fetchPlans() {
    try {
        const response = yield call(getPlans)
        yield put(getPlansSuccess(response))
    } catch (error) {
        yield put(getPlansFail(error))
    }
}

function* onAddNewPlan({ payload: plan }) {
    try {
        const response = yield call(addNewPlan, plan)
        yield put(addNewPlanSuccess(response))
    } catch (error) {
        yield put(addNewPlanFail(error))
    }
}

function* onUpdatePlan({ payload: plan }) {
    try {
        const response = yield call(updatePlan, plan)
        yield put(updatePlanSuccess(response))
    } catch (error) {
        yield put(updatePlanFail(error))
    }
}

function* onDeletePlan({ payload: plan }) {
    try {
        const response = yield call(deletePlan, plan.id)
        yield put(deletePlanSuccess(plan))
    } catch (error) {
        yield put(deletePlanFail(error))
    }
}

function* plansSaga() {
    yield takeEvery(GET_PLANS, fetchPlans)
    yield takeEvery(ADD_NEW_PLAN, onAddNewPlan)
    yield takeEvery(UPDATE_PLAN, onUpdatePlan)
    yield takeEvery(DELETE_PLAN, onDeletePlan)
}

export default plansSaga
